export const AUTH_STORAGE_KEYS = {
  token: 'token',
  tokenExpiresAt: 'tokenExpiresAt',
  refreshToken: 'refreshToken',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
} as const

export type AuthStoragePayload = {
  token: string
  tokenExpiresAt: string
  refreshToken: string
  refreshTokenExpiresAt: string
}

export const set = (key: string, value: string) => {
  localStorage.setItem(key, value)
}

export const remove = (key: string) => {
  localStorage.removeItem(key)
}

export const get = (key: string) => {
  return localStorage.getItem(key)
}

export const clear = () => {
  localStorage.clear()
}

export const setAuthStorage = (payload: AuthStoragePayload) => {
  set(AUTH_STORAGE_KEYS.token, payload.token)
  set(AUTH_STORAGE_KEYS.tokenExpiresAt, payload.tokenExpiresAt)
  set(AUTH_STORAGE_KEYS.refreshToken, payload.refreshToken)
  set(AUTH_STORAGE_KEYS.refreshTokenExpiresAt, payload.refreshTokenExpiresAt)
}

export const clearAuthStorage = () => {
  remove(AUTH_STORAGE_KEYS.token)
  remove(AUTH_STORAGE_KEYS.tokenExpiresAt)
  remove(AUTH_STORAGE_KEYS.refreshToken)
  remove(AUTH_STORAGE_KEYS.refreshTokenExpiresAt)
}
